import { Img } from 'react-image';
export var GracefulImage = Img;
//# sourceMappingURL=graceful-image.js.map